function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Expand(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2 23.008a1.003 1.003 0 01-.337-.058l-.027-.01a.995.995 0 01-.012-.005l-.02-.008a.996.996 0 01-.084-.041l-.014-.008a.98.98 0 01-.098-.064l-.02-.015a.327.327 0 01-.013-.01l-.082-.073a1.005 1.005 0 01-.074-.082l-.006-.009.08.09a1.012 1.012 0 01-.282-.558 1.125 1.125 0 01-.011-.13v-6.492a1 1 0 012 0v4.06l6.219-6.22a1 1 0 011.414 1.413l-6.22 6.22h4.06a1 1 0 110 2H2zM22.04 1l.04.002c.011 0 .023 0 .035.002L22.04.999c.057 0 .112.005.166.014l.024.005h.001l.039.008a.993.993 0 01.041.01l.043.014a.773.773 0 01.068.025l.033.014a.875.875 0 01.078.04l.027.016a.936.936 0 01.083.057l.01.007a.972.972 0 01.095.083l.073.082.007.009.002.004.01.011c.016.021.03.043.045.065l.007.013a.994.994 0 01.074.145l.016.041a.992.992 0 01.011.034l.01.034a.893.893 0 01.02.08l.005.032a.899.899 0 01.012.157v6.473a1 1 0 11-2 0V4.413l-6.219 6.22a.997.997 0 01-1.414 0 .999.999 0 010-1.414L19.627 3H15.57a1 1 0 110-2h6.471z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoExpand = /*#__PURE__*/React.memo(Expand);
export default MemoExpand;